module.exports = ".spinner {\n  z-index: 1051 !important;\n}\n.spinner-backdrop {\n  z-index: 1051 !important;\n}\n"